import { BellRing } from "lucide-react";

const ComingSoon = () => {
  return (
    <div className="flex justify-center items-center container mx-auto my-auto max-h-full px-4">
      <div className="flex flex-col items-center justify-center h-screen space-y-3">
        <div>
          <BellRing
            className="h-16 w-16 text-primary animate-pulse"
            aria-label="Coming Soon"
          />
        </div>

        <h1 className="text-3xl font-bold text-center">Coming Soon</h1>
        <p className="text-center text-gray-600">
          This feature is under development. Stay tuned!
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
